export const TABLE_DEFAULT_PAGE_SIZE = 100;

export const TABLE_PAGE_SIZE_OPTIONS = [100, 250, 500, 1000];
